<template>
  <v-container grid-list-xl>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-flex v-for="portfolio in portfolios" :key="portfolio.src" xs12 sm12 md4 lg4 xl4>
        <v-card
          :to="'/portfolio/'+(portfolio.goTo).toLowerCase()"
          hover
          flat
          color="transparent"
          height="230"
        >
          <v-card-title></v-card-title>
          <v-img :src="portfolio.src" aspect-ratio="2.75" height="130" contain></v-img>
          <v-card-title primary-title class="justify-center">
            <v-flex text-xs-center subheading font-weight-bold>{{portfolio.title}}</v-flex>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  metaInfo: {
    title: 'Portfolio',
    titleTemplate: "%s ← Mathieu's Space",
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      {
        name: 'description',
        content:
          "Mathieu Baesen's Portfolio Web Development Video game development Data Science"
      },
      { charset: 'utf-8' },
      { property: 'og:title', content: "Mathieu' Space" },
      { property: 'og:site_name', content: "Mathieu' Space" },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://Mathieu.space' },
      {
        property: 'og:description',
        content:
          "Mathieu Baesen's Portfolio Web Development Video game development"
      }
    ]
  },
  data () {
    return {
      portfolios: [
        {
          src: 'https://i.imgur.com/4gd5ytO.png', /*'https://as1.ftcdn.net/v2/jpg/01/71/29/48/1000_F_171294824_FDLwEWTzlfVr8iE0qojO0mmai44fdbIj.jpg',*/
          goTo:'Games',
          title: 'Video Games'
        },
        {
          src:'https://i.imgur.com/vpWZtTw.jpg',
          goTo:'Programming',
          title:'Programming (Others)'
        },
        {
          src:'https://i.imgur.com/xUvzNYk.jpg',
          goTo:'AllGames',
          title:'Narrative Design and Writing'
        },
        {
          src: 'https://i.imgur.com/uoRdiFK.jpg',
          goTo:'Articles',
          title: 'Articles'
        },
        {
          src:'https://i.imgur.com/Nl4o2Xp.png',
          goTo:'Autres',
          title: 'Others (Music Composition, etc.)'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
